import React, { useEffect, useState } from 'react';
import MoreHorzIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
interface PopOverMenuProps {
  menuItems: any[];
  handleMenuClick(type: any): void;
  isVertical?: boolean;
  title?: string;
  sx?: any;
}
const PopOverMenuComponent: React.FC<PopOverMenuProps> = ({
  menuItems,
  handleMenuClick,
  isVertical,
  title,

  sx,
}) => {
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMoreIconClick = (event: any) => {
    setAnchorEl(event?.currentTarget);
    //setCurrentMenuIcon(id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div key={'PopOverMenu'} style={sx}>
      <IconButton
        id={'more-button'}
        onClick={handleMoreIconClick}
        sx={{ position: 'relative' }}
      >
        {isVertical ? <MoreVertIcon /> : <MoreHorzIcon />}
      </IconButton>
      <Menu
        id={'more-menu'}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          },
        }}
      >
        <MenuItem sx={{ fontWeight: 'bold' }}>
          {title ? title : 'More Links'}
        </MenuItem>
        {menuItems.map((item: any, index: number) => {
          return (
            <MenuItem
              sx={{ listStyleType: 'disc' }}
              key={'aprv_q' + index + '_' + item.label}
              onClick={() => {
                handleMenuClick(item.type);
                handleClose();
              }}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
export default PopOverMenuComponent;
